
import { ArrowUpRight } from 'react-feather';
import './Login.scss';
import logo from './regulaid-logo.png';
import { useEffect, useRef } from 'react';
import api from './api/axios';

function Login() {

  const handleLogin = async () => {
    
    window.location.href = "http://regulaid.thinkific.com/oauth2/authorize?client_id=7b1de2e496d6113ac6cf1bca7634b8ce&redirect_uri=https%3A%2F%2Fadmin.regulaid.de&response_type=code&scope=openid%20profile%20email%20site&nonce=woid29jjJB1bb";

  };

  async function fetchTest() {
    try {
      const response = await api.get('/scrape');

    } catch (error: any) {
      console.error('⚠️ Test Error:', error.response?.data || error.message);
    }
  }

  async function fillEnrollments() {
    try {
      const response = await api.get('/fillEnrollments');

    } catch (error: any) {
      console.error('⚠️ Test Error:', error.response?.data || error.message);
    }
  }

  const downloadCertificate = (certificateId: string) => {
    const baseUrl = 'https://ki-campus.regulaid.de/';
    const pdfUrl = `${baseUrl}/student_certificates/${certificateId}`;
  
    // Erstelle ein unsichtbares <a> Element und löse den Download aus
    const a = document.createElement('a');
    a.href = pdfUrl;
    a.download = `certificate_${certificateId}.pdf`; // optional: der Dateiname
    a.click();
  };

  const downloadAllCertificates = () => {
    const certificateIds = ['2p2n5acwul'];

    certificateIds.forEach(certificateId => {
      downloadCertificate(certificateId);
    });
  };

  

  return (
    <div className="center-container">
      {false && <>
        <button onClick={() => fetchTest()}>Scrape</button>
        <button onClick={() => fillEnrollments()}>Fill enrollments</button>
        <button onClick={() => downloadAllCertificates()}>Certificates</button>
      </>}
      <div className="login-container">
        <div style={{display: 'flex', justifyContent: 'center', marginBottom: '20px'}}>
          <img src={logo} alt="Regulaid Logo" className="login-logo" />
        </div>
        
        <h1>
          KI-Campus Admin Dashboard
        </h1>

        <div className="benefits">
          <div className="your-benefits">
            Alles auf einen Blick
          </div>
          <div className="benefit"><svg className="check" width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22 11.0857V12.0057C21.9988 14.1621 21.3005 16.2604 20.0093 17.9875C18.7182 19.7147 16.9033 20.9782 14.8354 21.5896C12.7674 22.201 10.5573 22.1276 8.53447 21.3803C6.51168 20.633 4.78465 19.2518 3.61096 17.4428C2.43727 15.6338 1.87979 13.4938 2.02168 11.342C2.16356 9.19029 2.99721 7.14205 4.39828 5.5028C5.79935 3.86354 7.69279 2.72111 9.79619 2.24587C11.8996 1.77063 14.1003 1.98806 16.07 2.86572M22 4L12 14.01L9 11.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg> Lizenzennutzung verwalten
          </div>
          <div className="benefit"><svg className="check" width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22 11.0857V12.0057C21.9988 14.1621 21.3005 16.2604 20.0093 17.9875C18.7182 19.7147 16.9033 20.9782 14.8354 21.5896C12.7674 22.201 10.5573 22.1276 8.53447 21.3803C6.51168 20.633 4.78465 19.2518 3.61096 17.4428C2.43727 15.6338 1.87979 13.4938 2.02168 11.342C2.16356 9.19029 2.99721 7.14205 4.39828 5.5028C5.79935 3.86354 7.69279 2.72111 9.79619 2.24587C11.8996 1.77063 14.1003 1.98806 16.07 2.86572M22 4L12 14.01L9 11.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg> Kursabschlüsse anzeigen
          </div>
          <div className="benefit"><svg className="check" width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22 11.0857V12.0057C21.9988 14.1621 21.3005 16.2604 20.0093 17.9875C18.7182 19.7147 16.9033 20.9782 14.8354 21.5896C12.7674 22.201 10.5573 22.1276 8.53447 21.3803C6.51168 20.633 4.78465 19.2518 3.61096 17.4428C2.43727 15.6338 1.87979 13.4938 2.02168 11.342C2.16356 9.19029 2.99721 7.14205 4.39828 5.5028C5.79935 3.86354 7.69279 2.72111 9.79619 2.24587C11.8996 1.77063 14.1003 1.98806 16.07 2.86572M22 4L12 14.01L9 11.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg> Zertifizierungen einsehen
          </div>
        </div>

        <button className='login-button' onClick={() => handleLogin()}>Anmelden <ArrowUpRight height={20} /></button>

      </div>
    </div>
  )
}

export default Login;
